import axiosInstance from "../../services/axios";
import { ActionTypes } from "../type";
import { setSession, resetSession } from "../../services/sessions";
import { validateToken, validateTokenValue } from "../../services/jwt";
import jwtDecode from "jwt-decode";

export const getToken = async (username, password) => {
  const formData = new FormData();
  formData.append("username", username);
  formData.append("password", password);
  try {
    const response = await axiosInstance.post("/auth/login", formData);
    setSession(response.data.access_token, response.data.refresh_token);
  } catch (error) {
    throw error;
  }
};

export const initialize = (isAuthenticated, user, token_values) => {
  return {
    type: ActionTypes.INITIALIZE,
    payload: {
      isAuthenticated,
      user,
      token_values,
    },
  };
};

export const loginUser = (username, password, onError) => async (dispatch) => {
  try {
    await getToken(username, password);
    const response = await axiosInstance.get("/hrms/me");
    const { data: user } = response;
    localStorage.setItem("company_id", user?.company_id)
    if (user.zone_id) {
      localStorage.setItem("zone_id", user.zone_id);
    }
    if (user?.zone_name) {
      localStorage.setItem("zone_name", user.zone_name);
    }
    const accessToken = localStorage.getItem("accessToken");
    let subObject = {};
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        subObject = JSON.parse(
          decoded.sub.replace(/'/g, '"').replace(/None/g, "null"),
        );
        const franchiseId = subObject?.franchise_id;
        localStorage.setItem("franchise_id", franchiseId);
        const employeeCodeId = subObject.employee_code_id;
        localStorage.setItem("employee_code_id", employeeCodeId);
        if ("franchise_payment_mode" in subObject) {
          localStorage.setItem(
            "franchise_payment_mode",
            subObject.franchise_payment_mode,
          );
        }
        if ("is_franchise_employee" in subObject) {
          localStorage.setItem(
            "is_franchise_employee",
            subObject.is_franchise_employee,
          );
        }
        if ("is_super_franchise" in subObject) {
          localStorage.setItem(
            "is_super_franchise",
            subObject.is_super_franchise,
          );
        }
        if ("sub_franchise" in subObject) {
          localStorage.setItem("sub_franchise", subObject.sub_franchise);
        }
      } catch (error) {
        console.error("Failed to decode JWT", error);
      }
    }
    dispatch({
      type: ActionTypes.LOGIN,
      payload: {
        user,
        subObject,
      },
    });
    return { success: true, user, subObject };
  } catch (err) {
    const errorMessage =
      err.response?.data?.detail ||
      "Invalid email or password. Please try again.";
    if (onError) onError(errorMessage);
    return { success: false, message: errorMessage };
    //errorNotification("Email or password is wrong")
    //const {data} = err.response
    // general_notification(data.detail)
  }
};

export const AuthProvider = () => async (dispatch) => {
  dispatch({
    type: ActionTypes.LOADING,
    payload: {
      loading: true,
    },
  });
  try {
    const accessToken = localStorage.getItem("accessToken");
    const token_values = validateTokenValue(accessToken);
    if (accessToken && validateToken(accessToken)) {
      setSession(accessToken);
      const response = await axiosInstance.get("/hrms/me");
      const { data: user } = response;
      dispatch({
        type: ActionTypes.INITIALIZE,
        payload: {
          isAuthenticated: true,
          user,
          token_values,
        },
      });
    } else {
      dispatch({
        type: ActionTypes.INITIALIZE,
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ActionTypes.INITIALIZE,
      payload: {
        isAuthenticated: false,
        user: null,
      },
    });
  }

  dispatch({
    type: ActionTypes.LOADING,
    payload: {
      loading: false,
    },
  });
};

export const logout = () => async (dispatch) => {
  localStorage.clear();

  localStorage.removeItem("franchise_payment_mode");
  localStorage.removeItem("is_franchise_employee");
  localStorage.removeItem("is_super_franchise");
  localStorage.removeItem("employee_code_id");
  localStorage.removeItem("franchise_id");
  localStorage.removeItem("fcm_token");
  localStorage.removeItem("sub_franchise");
  localStorage.removeItem("new_registration_franchise_id");
  localStorage.removeItem("zone_id");
  resetSession();
  dispatch({
    type: ActionTypes.LOGOUT,
  });
};
